import {createApp} from 'vue'
import VueCookies from 'vue-cookies'
import AppAnswer from './answer.vue'
import AppAttachment from './attachment.vue'
import FinanceConsider from './financeconsider.vue'
import {AnswerStore} from './AnswerStore'

const AppQuestions = {
    template: '#app-questions',

    components: {
        AppAnswer,
        AppAttachment,
        FinanceConsider
    },

    data() {
        return {
            // Error message handling
            error: false,
            errormsg: '',

            //Text to show on the Save button
            savebuttontext: '',

            //Is the category marked as complete
            iscomplete: false,

            //Last sync time, and a property just to hold the sync timer we set later
            //We set the last sync time to when the page loads, since that is when the first sync happens
            lastsync: Date.now(),
            previoussync: 0,
            synctimer: null,

            //The data store shared with the AppAnswers so we can access their properties
            AnswerStore
        }
    },

    props: {
        maxwords: Number,
        idappcode: String,
        routecategories: String,
        routependingverify: String,
        idcategory: Number,
        state: String,
        syncfrequency: Number,
    },

    computed: {

        wordcountexceeded() {
            return (this.totalwords > this.maxwords)
        },

        // Total number of words in each answer (that requires them to be counted)
        totalwords() {
            let i = 0
            for (let a in this.AnswerStore.wordcounts) {
                if (this.AnswerStore.countwords[a]) {
                    i += this.AnswerStore.wordcounts[a]
                }
            }
            return i
        },

        // Do all answers pass their own requirements
        allsatisfied() {
            for (let a in this.AnswerStore.satisfiedes) {
                if (this.AnswerStore.satisfiedes[a] === false) {
                    return false
                }
            }
            return true
        },

    },

    watch: {

        error: function (newval) {
            if (newval === true) {
                setTimeout(function () {
                    this.error = false;
                }.bind(this), 5000)
            }
        }


    },


    methods: {

        // The save button at the bottom of the page
        doSave: function () {
            this.doUploadAnswers('save', 'all')
        },


        doGoCategories: function () {
            window.location = this.routecategories

        },

        doUploadAnswers: function (action, uploadtype) {
            //Build an array for all the answers we are uploading
            let answers = []

            for (let idquestion in this.AnswerStore.lastmodifieds) {

                switch (uploadtype) {

                    case 'all':
                        //Upload all answers
                        answers.push({
                            idquestion: idquestion,
                            answer: this.AnswerStore.answers[idquestion],
                            lastmodified: this.AnswerStore.lastmodifieds[idquestion],
                            wordcount: this.AnswerStore.wordcounts[idquestion]
                        })
                        break;

                    case 'changed':
                        //Upload only answers changed since the last upload
                        if (this.AnswerStore.lastmodifieds[idquestion] > this.lastsync) {
                            answers.push({
                                idquestion: idquestion,
                                answer: this.AnswerStore.answers[idquestion],
                                lastmodified: this.AnswerStore.lastmodifieds[idquestion],
                                wordcount: this.AnswerStore.wordcounts[idquestion]
                            })
                        }

                        break;
                }

            }

            //Update the last sync time before we do the actual sync, we'll set it back if the upload fails.
            // We do it before the upload because the upload can take time, and answer changes made after the upload starts, but before it completes, would be lost
            this.previoussync = this.lastsync
            this.lastsync = Date.now()

            // Now we can upload the answers

            if (answers.length > 0) {

                jQuery.ajax({
                    url: themosis.ajaxurl,
                    dataType: 'json',
                    type: 'POST',
                    data: {
                        action: 'application-putanswers',
                        security: themosis.nonce,
                        answers: answers,
                        idappcode: this.idappcode,
                    }
                }).done(function (r) {

                    if (r.error !== 'none') {
                        this.errormsg = 'Error on answer save: ' + r.error
                        this.error = true

                        //If upload fails, set the sync time back so we don't miss any changes
                        this.lastsync = this.previoussync

                    } else {

                        //Success!
                        this.postUploadAnswers(action)


                    }
                }.bind(this)).fail(function (j, error) {
                    this.errormsg = 'Communication error: ' + error
                    this.error = true

                    //If upload fails, set the sync time back so we don't miss any changes
                    this.lastsync = this.previoussync
                }.bind(this))

            } else {
                // There were no changes to upload
                this.postUploadAnswers(action)
            }


        },

        //What we do after a successful doUploadAnswers
        postUploadAnswers(action) {

            // If we are saving then we've got some stuff to do!
            if (action === 'save') {

                switch (this.state) {
                    case 'new':
                        // If this is the 'new' state, then we want to go to the verification page
                        window.location = this.routependingverify

                        break;
                    case 'verified':
                        // Answers are safely uploaded, now we need to see if we're completing. We'll never be here with complete set to true if we haven't just set it now

                        if (this.iscomplete) {
                            this.doUploadCompleteCategory()

                        } else {
                            // Nothing else to do here just go to the categories page
                            this.doGoCategories()
                        }
                        break;

                }
            } else {
                //Do nothing (we're just uploading answers by the timer)
            }

        },

        /**
         * Download answers for the given category
         * Don't use this, it's just here for posterity.
         */
        doDownloadAnswers: function () {
            let answercategories = []
            //If we are verified, then when we're answering questions we need 0, 1 and the curent category
            //If we are not verified, then we're only ever going to be answering category 0 regardless of the selected category
            if (this.state === 'verified') {
                answercategories = [0, 1, this.idcategory]
            } else {
                answercategories = [0]
            }


            jQuery.ajax({
                url: themosis.ajaxurl,
                dataType: 'json',
                type: 'POST',
                data: {
                    action: 'application-getanswers',
                    security: themosis.nonce,
                    idappcode: this.idappcode,
                    categories: answercategories
                }
            }).done(function (r) {

                if (typeof (r.error) !== 'undefined') {

                    this.errormsg = 'Error on answer download: ' + r.error
                    this.error = true

                } else {

                    //Success!
                    this.postDownloadAnswers(r)


                }
            }.bind(this)).fail(function (j, error) {
                this.errormsg = 'Communication error: ' + error
                this.error = true
            }.bind(this))
        },

        /**
         * Process the answers we've downloaded from doDownloadAnswers
         * Don't use this, it's just here for posterity.
         */
        postDownloadAnswers(answers) {

            for (let a in answers) {
                let answer = answers[a]

                // If we don't have this answer in the store, just create it and set it to nothing
                if (typeof (this.AnswerStore.lastmodifieds[answer.idquestion]) === 'undefined') {
                    this.AnswerStore.answers[answer.idquestion] = ''
                    this.AnswerStore.lastmodifieds[answer.idquestion] = 0
                    this.AnswerStore.wordcounts[answer.idquestion] = 0
                }

                // If the lastmodified in the answer is more recent than the one we have, replace it. Otherwise, ignore.
                if (this.AnswerStore.lastmodifieds[answer.idquestion] < answer.lastmodified) {
                    // Answer we have is older, replace it.
                    this.AnswerStore.answers[answer.idquestion] = answer.answer
                    this.AnswerStore.lastmodifieds[answer.idquestion] = answer.lastmodified
                    this.AnswerStore.wordcounts[answer.idquestion] = answer.wordcount
                }


            }

        },

        doUploadCompleteCategory() {
            jQuery.ajax({
                url: themosis.ajaxurl,
                dataType: 'json',
                type: 'POST',
                data: {
                    action: 'application-putcompletedcategories',
                    security: themosis.nonce,
                    idappcode: this.idappcode,
                    completedcategories: [this.idcategory]
                }
            }).done(function (r) {

                if (r.error !== 'none') {
                    this.errormsg = 'Error on category completion upload: ' + r.error

                    this.error = true

                } else {

                    //Success!
                    this.postUploadCompleteCategory()


                }
            }.bind(this)).fail(function (j, error) {
                this.errormsg = 'Communication error: ' + error
                this.error = true
            }.bind(this))
        },

        /**
         * Post uploading of completed category
         * We'll only be doing this if the user is saving and wants to finalise, so we will always want to just redirect away
         * We put this in a separate function anyway though
         */
        postUploadCompleteCategory() {
            this.doGoCategories()
        }


    },

    created: function () {
    },

    mounted() {
        switch (this.state) {
            case 'new':
                this.savebuttontext = 'Save and Send Email Verification Link'
                break;

        }

        // Start the answer uploader
        this.synctimer = setInterval(() => {
            this.doUploadAnswers('sync', 'changed')
        }, this.syncfrequency)

    }

}

// Create the vue app, add the component to it, then mount into the container #questions
const questions = createApp();
questions.use(VueCookies)
questions.component('AppQuestions', AppQuestions)

if (document.getElementById('questions')) {
    questions.mount('#questions')
}